import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    menuTitle: null,
    createSectionStatus: null,
    sectionData: null,
    message: null,
    error: null,
    isLoading: false
}

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        updateMenuTitle: (state, action) => {
            state.menuTitle = action.payload;
        },
        getSidebarSectionListStart: (state) => {
            state.isLoading = true;
            state.sectionData = null;
            state.error = null;
            state.message = null;
        },
        getSidebarSectionListSuccess: (state, action) => {
            state.sectionData = action?.payload?.sidebar_sections;
            state.isLoading = false;
        },
        getSidebarSectionListFailure: (state, action) => {
            state.error = true;
            state.message = action?.payload?.message;
            state.isLoading = false;
        },
        createSidebarSectionStart: (state) => {
            state.isLoading = true;
            state.message = null;
            state.createSectionStatus = null;
            state.error = null;
        },
        createSidebarSectionSuccess: (state, action) => {
            state.message = action?.payload?.message;
            state.isLoading = false;
            state.createSectionStatus = action?.payload?.success
        },
        createSidebarSectionFailure: (state, action) => {
            state.error = true;
            state.message = action?.payload?.message;
            state.isLoading = false;
        },
    }
})

export const {
    updateMenuTitle,
    getSidebarSectionListStart,
    getSidebarSectionListSuccess,
    getSidebarSectionListFailure,
    createSidebarSectionStart,
    createSidebarSectionSuccess,
    createSidebarSectionFailure
} = sidebarSlice?.actions;

export default sidebarSlice.reducer;